import { useMutation } from "@tanstack/react-query";
import { LoginData, LoginResponse, UserDto } from "./type";
import { loginUser } from "./api";
import { AxiosError } from "axios";

export const useLogin = () => {
    return useMutation<UserDto, AxiosError, LoginData>({
        mutationFn: loginUser, // Fonction qui effectue le POST
        retry: 2, // Réessaie 2 fois en cas d'échec
    });
};